import { render, staticRenderFns } from "./deductionDetail-negative.vue?vue&type=template&id=9cb1a844&scoped=true"
import script from "./deductionDetail-negative.vue?vue&type=script&lang=js"
export * from "./deductionDetail-negative.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail-negative.vue?vue&type=style&index=0&id=9cb1a844&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb1a844",
  null
  
)

export default component.exports